import { CYCLE_PHASE_DRAWER_COLORS } from '@/pages/HomeV2/utils/chartSeriesColors';

const PHASES = [
  { key: 'pickup_hours', label: 'Pre-pickup' },
  { key: 'dwelling_hours', label: 'Hub / Customs' },
  { key: 'moving_hours', label: 'In transit' },
  { key: 'delivery_attempt_hours', label: 'Failed delivery attempt' },
  { key: 'last_mile_hours', label: 'Last mile delivery' },
] as const;

export type CyclePhaseKey = (typeof PHASES)[number]['key'];

export const CYCLE_TIME_PHASES = PHASES.map((phase) => ({
  ...phase,
  color: CYCLE_PHASE_DRAWER_COLORS[phase.key],
}));
